import { getIframe } from '../helpers';

/**
 * 유효값 체크
 * @params {All} value
 * @retrun {Boolean}
 */
export function isEmpty(value) {
  if (value === null) return true;
  if (typeof value === 'undefined') return true;
  if (typeof value === 'string' && value === '') return true;
  if (Array.isArray(value) && value.length < 1) return true;
  if (
    typeof value === 'object' &&
    value.constructor.name === 'Object' &&
    Object.keys(value).length < 1 &&
    Object.getOwnPropertyNames(value) < 1
  )
    return true;
  if (
    typeof value === 'object' &&
    value.constructor.name === 'String' &&
    Object.keys(value).length < 1
  )
    return true;
  return false;
}

/**
 * 금액 콤마 포매터
 * @params {String} param
 * @retrun {String}
 */
export const amtFormatter = (param) => {
  if (isEmpty(param)) return param;
  const strParam = param.toString();
  const value = strParam.includes('.')
    ? strParam.substring(0, strParam.indexOf('.')).trim()
    : strParam.trim();
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/**
 * 콤마 제거
 * @params {String} param
 * @retrun {String}
 */
export const removeComma = (param) => {
  if (isEmpty(param) || !param.toString().includes(',')) return param;
  const strParam = param.toString();
  return strParam.replace(/,/g, '');
};
